import React, { lazy } from 'react';
import { LoadComponent, type RouteObject } from 'Routes/index';

const Office = React.lazy(() => import(`Pages/Screens/Office/Office/Page`));

const OfficeRoute: RouteObject[] = [
  {
    path: 'escritorio',
    element: <LoadComponent component={Office} />,
  },
]

export default OfficeRoute;